import { BaseComponent } from '../models/components/BaseComponent';

export function componentsContain(components:Array<BaseComponent>,className: string):boolean{
    let result = [];
    for (let index = 0; index < components.length; index++) {
        const element = components[index];
        if(element.componentType == className)
            result.push(element);
    }
    return result.length > 0 ? true:false;
}